import { typography } from "../typography/typography.js";
import "../typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../typography/utils/typographyVariants/typographyVariants.js";
const MuiTooltip = {
  styleOverrides: {
    tooltip: ({ theme }) => ({
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.grey[50],
      borderRadius: "4px",
      padding: "8px 16px",
      ...typography["Lato Caption"],
      [theme.breakpoints.up("sm")]: {
        ...typography["Lato Caption Small"],
        padding: "4px 8px"
      }
    }),
    popper: ({ ownerState }) => ({
      ...ownerState.arrow && {
        '&[data-popper-placement*="bottom"] .MuiTooltip-arrow': {
          marginTop: "-8px",
          "&::before": {
            transformOrigin: "unset",
            transform: "rotate(0deg)"
          }
        },
        '&[data-popper-placement*="top"] .MuiTooltip-arrow': {
          marginBottom: "-8px",
          "&::before": {
            transformOrigin: "unset",
            transform: "rotate(180deg)"
          }
        },
        '&[data-popper-placement*="right"] .MuiTooltip-arrow': {
          width: "16px",
          height: " 16px",
          marginLeft: "-8px",
          "&::before": {
            transformOrigin: "unset",
            transform: "rotate(-90deg)"
          }
        },
        '&[data-popper-placement*="left"] .MuiTooltip-arrow': {
          width: "16px",
          height: " 16px",
          marginRight: "-8px",
          "&::before": {
            transformOrigin: "unset",
            transform: "rotate(90deg)"
          }
        }
      }
    }),
    arrow: ({ theme }) => ({
      color: theme.palette.grey[800],
      width: "16px",
      height: " 16px",
      "&::before": {
        clipPath: 'path("M7.87855 0C5.47368 1.1096e-07 4.17391 5.33333 0 8H7.87855H16C11.8261 5.33333 10.1053 -1.0274e-07 7.87855 0Z")',
        backgroundColor: theme.palette.grey[800],
        insetInlineStart: 0
      }
    })
  }
};
export {
  MuiTooltip
};
